"use client";

import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Images/SK_BLU.svg";

import mlogo from "../Images/SK_BLK_16x16.svg";

const navigation = [
  { name: "Home", path: "/" },
  { name: "Camping", path: "/camping" },
  { name: "Treks", path: "/SahyadriTreks" },
  { name: "Villas", path: "/villas" },
  { name: "Tour Packages", path: "/tour-packages" },
  { name: "Gallery", path: "/gallery" },
  // { name: "About Us", path: "/about-us" },
  // { name: "Contact Us", path: "/contact-us" },
];

export function NavBar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    setMobileMenuOpen(false); // Close mobile menu on navigation
  };

  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-blue-900/10 bg-white/95 shadow-sm backdrop-blur-md">
      <nav
        aria-label="Global"
        className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8"
      >
        {/* Logo */}
        <div className="flex lg:flex-1">
          <button
            type="button"
            onClick={() => navigate("/")} // Navigate to the home page
            className="-m-1.5 rounded-lg p-1.5"
          >
            <span className="sr-only">SKAdventures</span>
            <img alt="logo" src={logo} className="h-8 w-auto" />
          </button>
        </div>

        {/* Mobile menu toggle button */}
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="h-6 w-6" />
          </button>
        </div>

        {/* Desktop navigation links */}
        <div className="hidden items-center lg:flex lg:gap-x-1">
          {navigation.map((item) => (
            <button
              key={item.name}
              onClick={() => handleNavigation(item.path)}
              className="rounded-full px-3 py-2 text-sm font-semibold leading-6 text-slate-700 transition hover:bg-blue-100 hover:text-blue-950"
            >
              {item.name}
            </button>
          ))}
        </div>

        {/* Desktop login button */}
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          {/* <button
            onClick={() => handleNavigation("/login")}
            className="text-sm font-semibold leading-6 text-gray-900"
          >
            Log in <span aria-hidden="true">&rarr;</span>
          </button> */}
        </div>
      </nav>

      {/* Mobile Menu (Dialog) */}
      <Dialog
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        className="lg:hidden"
      >
        <div className="fixed inset-0 z-50" />
        <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-slate-50 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-blue-900/10">
          <div className="flex items-center justify-between">
            <button type="button" onClick={() => handleNavigation("/")} className="-m-1.5 rounded-lg p-1.5">
              <span className="sr-only">SKAdventures</span>
              <img alt="logo" src={mlogo} className="h-8 w-auto" />
            </button>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-slate-700"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>

          {/* Mobile Menu Links */}
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => handleNavigation(item.path)}
                    className="-mx-3 block w-full rounded-lg px-3 py-2 text-left text-base font-semibold leading-7 text-slate-800 transition hover:bg-blue-50 hover:text-blue-950"
                  >
                    {item.name}
                  </button>
                ))}
              </div>
              {/* Uncomment and add login link in mobile if needed */}
              {/* <div className="py-6">
                <button
                  onClick={() => handleNavigation("/login")}
                  className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Log in
                </button>
              </div> */}
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
}
